<h3 mat-dialog-title>Update Hub Status - ({{this.data.hubId}})</h3>

<div>
    <form action="">

    </form>
</div>

<div mat-dialog-content class="md-padding">

    <nb-card>
        <nb-card-body>
            <nb-toggle [(ngModel)]="initialData.lockHub" status="warning" labelPosition="start">Lock Hub only</nb-toggle>
            <br>
            <nb-toggle [(ngModel)]="initialData.blockHubFunctionality" status="danger" labelPosition="start">Lock Hub and
                Functionality</nb-toggle>
            <br>
            <textarea nbInput fullWidth placeholder="Reason" [(ngModel)]="initialData.reason"></textarea>
            <textarea nbInput fullWidth placeholder="Required Action" [(ngModel)]="initialData.requiredAction"></textarea>
            <br>
            <p>Enter the eGlu admin pin:</p>
            <nb-form-field>
                <input type="password" nbInput [(ngModel)]="initialData.eGluAdminPin" minlength="6">  
              </nb-form-field>
              <br>

            <p>Enter the pin received on email:</p>
            <nb-form-field>
                <input type="password" nbInput [(ngModel)]="initialData.userOtp" minlength="6" maxlength="6">
                <!-- <button nbSuffix nbButton ghost (click)="toggleShowPassword()">
                    <nb-icon [icon]="showPassword ? 'eye-outline' : 'eye-off-2-outline'" pack="eva"
                        [attr.aria-label]="showPassword ? 'hide password' : 'show password'">
                    </nb-icon>
                </button> -->
                <button mat-button color="accent" (click)="sendEmail()">Send Email</button>
            </nb-form-field>
            <br>
            <div mat-dialog-actions>
                <button mat-button (click)="onNoClick()">Cancel</button>
                <button mat-button (click)="verifyAndUpdateStatus(initialData)">Update</button>
            </div>
        </nb-card-body>
    </nb-card>
</div>
